import React from "react";
import PropTypes from "prop-types";
import CardBox from "../../../../shared/CardBox/CardBox";

const InfoBenefitCard = props => {
  return (
    <CardBox
      display="block"
      paddingTop={0}
      paddingLeft={0}
      paddingRight={0}
      paddingBottom={0}
      marginLeft={8}
      marginRight={8}
      marginTop={0}
      marginBottom={0}
      minWidth={260}
    >
      {props.children}
    </CardBox>
  );
};

InfoBenefitCard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InfoBenefitCard;
